module.exports = __webpack_public_path__ + "2c104a246f9e852e3347b10ceb2da7f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/23_PROP_01.png
// module id = 124
// module chunks = 0